<template>
  <div>
    <el-container>
      <el-header height="70px" class="el-header">
        <div class="divTitle">问答管理系统</div>
        <div style="float:right; width:165px; height:70px; cursor:pointer;">
           <span  style="color:white; font-size:15px;" v-if="isShow == '0'">
                {{userName}}
             </span>
          <el-dropdown trigger="click" @command="handleCommand" v-if="isShow!= '0'">
            <span class="el-dropdown-link" style="color:white; font-size:15px;">
              {{userName}}&nbsp;<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" >
<!--              <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>-->
              <el-dropdown-item command="doLogout"  >退&nbsp;&nbsp;&nbsp;&nbsp;出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container>
        <el-aside width="250px">
          <div style="overflow-x:hidden;">
            <!--<el-menu id="divMenu" style="width:251px;" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">-->
              <!--<el-menu-item :index="item.menuIndex" :key="item.menuIndex" v-for="item in menuList" @click="loadChildren(item.routerName)">-->
                <!--<i :class="item.iconClass"></i>-->
                <!--<span slot="title">{{item.menuName}}</span>-->
              <!--</el-menu-item>-->
            <!--</el-menu>-->
            <!--@open="handleOpen"
            @close="handleClose"-->
              <el-menu
                id="divMenu"
                :default-active="$route.path"
                class="el-menu-vertical-demo"
                text-color="#333333"
                :highlight-current = 'true'
                :router="true"
                active-text-color="#fff">
                <el-menu-item :index= "'/' +item.path" v-for="item in menuList " :key="item"  @click="loadChildren(item.path)">
                  <i :class="item.icon"></i>
<!--                  <span slot="title">{{item.name}}</span>-->
                  <span >{{item.name}}</span>
                </el-menu-item>

<!--                <el-menu-item  index="/personsend" @click="loadChildren('personsend')">-->
<!--                  <i class="el-icon-bell"></i>-->
<!--                  <span slot="title">问答管理</span>-->
<!--                </el-menu-item>-->
<!--                <el-menu-item  index="/hotquestion" @click="loadChildren('hotquestion')">-->
<!--                  <i class="el-icon-news"></i>-->
<!--                  <span slot="title">热点问题管理</span>-->
<!--                </el-menu-item>-->
<!--                <el-menu-item  index="/unknowQa" @click="loadChildren('unknowQa')">-->
<!--                  <i class="el-icon-chat-dot-round"></i>-->
<!--                  <span slot="title">未知问题管理</span>-->
<!--                </el-menu-item>-->
<!--                <el-menu-item  index="/qatotal" @click="loadChildren('qatotal')">-->
<!--                  <i class="el-icon-pie-chart"></i>-->
<!--                  <span slot="title">数据统计</span>-->
<!--                </el-menu-item>-->
<!--                <el-menu-item  index="/station" @click="loadChildren('station')">-->
<!--                  <i class="el-icon-setting"></i>-->
<!--                  <span slot="title">站点管理</span>-->
<!--                </el-menu-item>-->
<!--                <el-menu-item  index="/user" @click="loadChildren('user')">-->
<!--                  <i class="el-icon-user"></i>-->
<!--                  <span slot="title">用户管理</span>-->
<!--                </el-menu-item>-->
<!--                <el-menu-item  index="/config" @click="loadChildren('config')">-->
<!--                  <i class="el-icon-setting"></i>-->
<!--                  <span slot="title">系统配置管理</span>-->
<!--                </el-menu-item>-->
              </el-menu>

          </div>
        </el-aside>
        <el-container style="background-color: #eff0f5">
          <div  v-show="stationFlag">
            <el-main style="width: 300px; background-color: #ffffff;height: 90vh">
              <el-row>
                 <el-col :span="24">
                   <div style="padding: 10px">
                     <el-input placeholder="请输入站点名称" @input="getStations" v-model="stationName" suffix-icon="el-icon-search"/>
                   </div>
                 </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-tree :data="stationList"
                           :props="defaultProps"
                           node-key="id"
                           ref ='tree'
                           :highlight-current="true"
                           @node-click="clickStation"
                  >

                  </el-tree>
                </el-col>
              </el-row>
            </el-main>
          </div>
          <el-main style="position: relative">
            <div id="divMain" style="position: relative;height: 100%;width: 100%">
              <router-view ref="child"></router-view>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </el-container>

    <el-dialog
      title="密码修改"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :close-on-click-modal="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
          <el-form-item label="账号">
            <span>{{ userName }}</span>
          </el-form-item>
<!--          <el-form-item label="原密码" prop="password">-->
<!--            <el-input type="password" v-model="dataForm.password"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="新密码" prop="newPassword">
            <el-input type="password" v-model="dataForm.newPassword" maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input type="password" v-model="dataForm.confirmPassword" maxlength="16"></el-input>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import $ from 'jquery'

import {updatePassword} from '@/api/common'
import {getOBj, get} from '@/api/common'

export default {
  name: 'index',
  data () {
    var validateConfirmPassword = (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入6到16位有效密码，必须是字母和数字'))
      } else if (this.dataForm.newPassword !== value) {
        callback(new Error('确认密码与新密码不一致'))
      } else {
        callback()
      }
    }
    return {
      menuList: [ ],
      stationName: '',
      stationList: [ ],
      stationData: [{label: 'xxx站点', id: '1'}, {label: 'xxx1站点', id: '2'}],
      menuName: '',
      defaultProps: {
        // children: 'children',
        label: 'name'
      },

      dataForm: {
        // password: '',
        newPassword: '',
        confirmPassword: ''
      },

      dataRule: {
        // password: [
        //   { required: true, message: '原密码不能为空', trigger: 'blur' }
        // ],
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
              if (!reg.test(value)) {
                callback(new Error('请输入6到16位有效密码，必须是字母和数字'))
              } else {
                callback()
              }
            },
            trigger: ['change']
          }
        ],
        confirmPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      pageSize: 10,
      pageNow: 0,
      stationFlag: true,
      activeIndex: '2',
      userName: '',
      Calendar: true,
      visit: false,
      isShow: '1',
      manages: false,
      meeting: false,
      questionnaire: true,
      location: 'Index',
      xiqing: false,
      organize: true,
      lawyer: false, // 律师
      jizhou: false,
      userType: ''
    }
  },
  computed: {
    epidemicCount () {
      return this.$store.getters.epidemicCount
    }
  },
  created: function () {
    let location = localStorage.getItem('location')
    this.userType = localStorage.getItem('userType')
    if (localStorage.getItem('userType') === 'adminUser') {
      this.userName = '管理员'
    } else {
      this.userName = localStorage.getItem('userCount')
    }
    console.log('===========', location)
    if (location === 'personsend') {
      this.activeIndex = '2'
    } else if (location === 'questionRecord') {
      this.activeIndex = '3'
    } else if (location === 'VisitsPage') {
      this.activeIndex = '4'
    } else if (location === 'manage') {
      this.activeIndex = '5'
    } else if (location === 'statistic') {
      this.activeIndex = '6'
    } else if (location === 'meeting') {
      this.activeIndex = '7'
    } else if (location === 'organize') {
      this.activeIndex = '9'
    } else if (location === 'Questionnaire') {
      this.activeIndex = '8'
    } else if (location === 'procuratorReservationMeet') {
      this.activeIndex = '10'
    } else if (location === 'procuratorStatistics') {
      this.activeIndex = '11'
    } else if (location === 'appointment') {
      this.activeIndex = '12'
    } else if (location === 'opinion') {
      this.activeIndex = '13'
    } else if (location === 'appeal') {
      this.activeIndex = '14'
    } else if (location === 'check') {
      this.activeIndex = '15'
    } else if (location === 'config') {
      this.activeIndex = '16'
    } else if (location === 'user') {
      this.activeIndex = '17'
    } else if (location === 'station') {
      this.activeIndex = '18'
    }
  },
  mounted: function () {
    let isCas = localStorage.getItem('isCas')
    if (isCas != null) {
      this.isShow = isCas
    }
    this.show()
    $('#divMenu').css('height', window.innerHeight - 70 + 'px')
    // $('#divMain').css('height', window.innerHeight - 112 + 'px')
    window.onresize = () => {
      return (() => {
        $('#divMenu').css('height', window.innerHeight - 70 + 'px')
        // $('#divMain').css('height', window.innerHeight - 112 + 'px')
      })()
    }
    let location = localStorage.getItem('location')
    if (location != null) {
      if (location === 'user') {
        this.stationFlag = false
      } else if (location === 'station') {
        this.stationFlag = false
      } else {
        this.stationFlag = true
      }
    }
    this.getMenuList()
    this.getStations()
  },
  methods: {
    getStations () {
      let url = '/site/queryByUserName'
      let param = {
        siteName: this.stationName
      }
      get(url, param).then(response => {
        if (response.data.code === 0) {
          this.stationList = response.data.data
          console.info(this.stationList)
        }
      })
    },
    getMenuList () {
      let url = '/menu/getMenuList'
      getOBj(url).then(response => {
        if (response.data.code === 0) {
          this.menuList = response.data.data
          console.info(this.menuList)
        }
      })
    },
    // 获取权限
    show: function (ev) {
      document.addEventListener('keydown', function (e) {
        if (e.keyCode === 116) {
          e.preventDefault()
          // 要做的其他事情
        }
      }, false)
    },
    clickStation (data) {
      console.info(data)
      console.log('===========', data)
      let location = localStorage.getItem('location')
      let params = {}
      if (location != null) {
        if (location === 'config') {
          params = {
            col: data.id
          }
          this.$refs.child.getQAList(params)
        } else if (location === 'qatotal') {
          this.$refs.child.getListbyBtn('week', data.id)
        } else if (location === 'hotquestion') {
          params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow,
            siteId: data.id,
            isHotQuestion: 'true',
            qaSelect: ''
          }
          this.$refs.child.getQAList(params)
        } else {
          params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow,
            siteId: data.id,
            qaSelect: ''
          }
          this.$refs.child.getQAList(params)
        }
      }

      // this.$router.push({path: '/' + this.menuName, query: { stationId: data.id }})
    },
    loadChildren: function (routerName) {
      if (routerName === 'SchedulCalendar') {
        window.open('http://47.95.7.8:8080/jfinal_cms/admin', '_blank')
      } else {
        this.stationName = ''
        // this.menuList = []
        this.getStations()
        // this.$refs.tree.setCurrentKey = null
        if (routerName === 'user') {
          this.stationFlag = false
        } else if (routerName === 'station') {
          this.stationFlag = false
        } else {
          this.stationFlag = true
        }

        localStorage.setItem('location', routerName)
      }
      // this.$router.push({
      //   name: routerName
      // })
    },
    update () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          this.$notify({
            title: '提示',
            message: '请检查输入的信息',
            type: 'success'
          })
          return false
        }
        let params = {}
        params.userId = localStorage.getItem('userId')
        params.userPasswd = this.dataForm.newPassword
        let url = '/update'
        updatePassword(url, params).then(response => {
          if (response.data.ret === 1) {
            this.$notify({
              title: '提示',
              message: response.data.message,
              type: 'success'
            })
            this.dialogVisible = false
          }
        }).catch(response => {
          this.$notify({
            title: '提示',
            message: '更新失败，请重试',
            type: 'warning'
          })
        })
      })
    },
    handleCommand: function (command) {
      if (command === 'changePwd') {
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
        })
        this.dialogVisible = true
      } else if (command === 'doLogout') {
        this.$confirm('确认要退出系统？', '操作提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'logout'
        }).then(() => {
          localStorage.setItem('userId', '')
          localStorage.setItem('userType', '')
          sessionStorage.setItem('token', '')
          localStorage.removeItem('isCas')
          this.$router.push({
            name: 'Login'
          })
        })
      }
    }
  },
  destroyed: function () {
    localStorage.removeItem('isCas')
  }
}
</script>

<style scoped>
  .divLogo {
    float: left;
    width: 70px;
    height: 70px;
  }
  .divTitle {
    float: left;
    font-family: '黑体', Serif;
    font-size: 25px;
    margin-left: 10px;
  }
  .el-header {
    background-color: #2c77ec;
    color: white;
    text-align: center;
    line-height: 70px;
  }
  .el-footer {
    background-color: #434A50;
    color: white;
    text-align: center;
    line-height: 30px;
  }
  .el-aside {
    color: #333;
    text-align: left;
    line-height: 200px;
    /*margin-top: 35px;*/
  }
  .el-main {
    background-color: #fff;
    color: #333;
    text-align: center;
    padding: 0;
    margin: 20px;
    border-radius: 5px;
  }
  .is-active{
    background-color: #409eff;
  }
  .el-menu-vertical-demo{
  }
</style>



// WEBPACK FOOTER //
// src/views/common/index.vue